import ImageUrlProfile from "components/app/image-url/ImageUrlProfile";
import { Service } from "utils/services";
import { useEffect, useState } from "react";
import LinkifyText from "components/app/linkify/LinkifyText";

export default function NewFeedRepostProfileContent({ post }: { post: any }) {
  const [userReaction, setUserReaction] = useState<any[]>([]);
  const [username1, setUsername1] = useState("");
  const [reactionTypeStr, setReactionTypeStr] = useState("");

  useEffect(() => {
    if (!post) return;

    let tmpUsers: any[];
    if (post.reaction_type === "Share") {
      setReactionTypeStr(" shared post from ");
      tmpUsers = [...post.share_users];
    } else {
      setReactionTypeStr(" liked ");
      tmpUsers = [...post.like_users];
    }

    const userIndex = tmpUsers.findIndex((user) => user.id.toString() === Service.userAuth.id.toString());

    if (userIndex !== -1) {
      tmpUsers.unshift(tmpUsers.splice(userIndex, 1)[0]);
    }

    const selectedUsers = tmpUsers.slice(0, 2);
    setUserReaction(selectedUsers);

    if (selectedUsers.length > 0) {
      setUsername1(selectedUsers[0].id.toString() === Service.userAuth.id.toString() ? "You" : selectedUsers[0].name);
    }
  }, [post]);

  return userReaction.length === 0 ? (
    <div className="h-5 w-32 bg-gray-200 animate-pulse rounded-md"></div> // 🔹 Show a smooth loading state
  ) : (
    <div className="flex flex-col border-b border-gray-300 pb-2 mb-2">
      <div className="flex flex-row items-center justify-between w-full">
        <div className="flex">
          {userReaction.length > 0 && (
            <div className="flex justify-center -space-x-3 rtl:space-x-reverse">
              {userReaction.map((likeUser: any, indexFriUser: number) => (
                <ImageUrlProfile key={indexFriUser} isLinkProfile={true} user={likeUser} className="w-6 h-6 border-2 border-white rounded-full dark:border-gray-800" alt="" />
              ))}
            </div>
          )}

          {userReaction.length === 1 ? (
            <div className="flex flex-row space-x-2 pl-2">
              <p className="text-base font-bold truncate">{username1}</p>
              <p className="text-base font-light text-muted-foreground truncate">{reactionTypeStr}</p>
              <p className="text-base font-bold truncate">{post?.re_post_user?.name}</p>
            </div>
          ) : (
            <div className="flex flex-row space-x-2 pl-2">
              <p className="font-bold truncate">{username1}</p>
              <p className="text-base font-light text-muted-foreground">and</p>
              <p className="font-bold truncate">{userReaction[1].name}</p>
              <p className="text-base font-light text-muted-foreground truncate">{reactionTypeStr}</p>
              <p className="font-bold truncate">{post?.re_post_user?.name}</p>
            </div>
          )}
        </div>
      </div>

      {post.media_share_title && (
        <div className="mt-2">
          <LinkifyText text={`${post.media_share_title}`} target="_blank" />
        </div>
      )}
    </div>
  );
}
